import type { LibraryTag } from 'pkg/api/models/library_tag';
import type { Record } from 'pkg/api/models/record';
import type { SessionBlockItem } from 'pkg/api/models/session_block_item';
import type { SessionGroup } from 'pkg/api/models/session_group';

export enum SessionBlockMode {
	// The whole team does the block together.
	Everyone = 'everyone',
	// The block runs as stations, each item assigned to a session group.
	Split = 'split',
}

export interface SessionBlockFocus extends Record {
	trainingSessionBlockId: number;
	libraryTagId: number;
	weight: number;
	libraryTag?: LibraryTag;
}

export interface SessionBlock extends Record {
	trainingSessionId: number;
	order: number;
	duration: number;
	title: string;
	description: string;
	mode: SessionBlockMode;
	// Off for blocks the generation engine must leave content-less by
	// design (a scrimmage, a game segment).
	generateContent: boolean;
	focus?: SessionBlockFocus[];
	items: SessionBlockItem[];
}

export interface SessionGroupCluster {
	key: string;
	group: SessionGroup | null;
	items: SessionBlockItem[];
}
